import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { FormGrid, SimpleDialog } from '../../../../toolympus/components/primitives';
import { FormControlsForFields, TableForFields } from '../../../../toolympus/components/schemed';
import { AbsenceExtraQuotaSchema } from '../data/types';
import { AbsenceExtraQuotasData } from '../data/useAbsenceExtraQuotas';

interface Props {
  data: AbsenceExtraQuotasData;
}

/**
 * Dialog for adding a new extra quota record
 */
export const AddExtraQuotaDialog = ({ data }: { data: AbsenceExtraQuotasData }) => {
  if (!data.addQuota.item) {
    return null;
  }

  return (
    <SimpleDialog
      {...data.addQuota.dialog}
      maxWidth="xs"
      dialogTitle="Добавить дополнительные дни"
      noFullscreen
      submitOnModEnter
      saveLabel="Добавить"
      save={() => data.addQuota.save()}
      cancelLabel="Отмена"
    >
      <FormGrid columns="1fr" noMargin>
        <FormControlsForFields
          data={data.addQuota.item}
          onChange={(o, c) => data.addQuota.update(c)}
          schema={AbsenceExtraQuotaSchema}
          fields={[
            ['days', { controlProps: { autoFocus: true } }],
            ['comment'],
            ['year'],
          ]}
        />
      </FormGrid>
    </SimpleDialog>
  );
};

/**
 * Main management dialog displaying employee quota list and actions
 */
export const AbsenceExtraQuotasDialog = ({ data }: Props) => {
  const employee = data.item;
  const fullName = employee
    ? `${employee.first_name} ${employee.last_name || ''}`.trim()
    : '';
  const title = `Дополнительные дни: ${fullName}`;
  const quotaList = data.quotas.data || [];

  if (!employee) {
    return null;
  }

  return (
    <>
      <SimpleDialog
        {...data.dialog}
        maxWidth="md"
        dialogTitle={title}
        noFullscreen
        noSave
        save={() => {}}
        cancelLabel="Закрыть"
        noSubmitOnEnter
        titleActions={<>
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => data.addQuota.start()}
          >
            Добавить дни
          </Button>
        </>}
      >
        {data.quotas.isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            {quotaList.length > 0 ? (
              <TableForFields
                fields={[
                  ["year"],
                  ["days"],
                  ["comment"],
                  ["created_by"],
                  ["created_at", { utcToLocal: true }],
                  ["actions", { label: " "}],
                ]}
                data={data.quotas.data}
                schema={AbsenceExtraQuotaSchema}
                fieldElement={f => {
                  if(f === "actions") {
                    return r => <>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => data.removeQuota.run(r)}>
                          <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </>
                  }
                }}
                />
              
            ) : (
              <Typography color="textSecondary" align="center" sx={{ py: 3 }}>
                Нет назначенных дополнительных квот
              </Typography>
            )}

          </Box>
        )}
      </SimpleDialog>

      {/* Creation Sub-Dialog */}
      <AddExtraQuotaDialog data={data} />
    </>
  );
};
